import axios from "axios";
import ApiConstants from "../Utils/ApiConstant";
import SessionManager from "../Utils/Session";
import dayjs from "dayjs";

const ReviewerService = {
 
 getAllReviewerQuestionList: async (selectedMedium,selectedClassFilter,selectedSubjectFilter) => {
    try {
      const response = await axios.get(
        ApiConstants.getAllReviewerQuestionList +
       `?medium=${selectedMedium}` + 
        `&class_id=${selectedClassFilter}` + 
        `&subject_id=${selectedSubjectFilter}`,
      {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  getAllReviewerSubQuestionList: async (question_id) => {
    try {
      const response = await axios.get(
        ApiConstants.getAllReviewerSubQuestionList + `?question_id=${question_id}`,
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  revieweraddSubQuestion: async (
    id,
    question,
    solution,
    correctOption,
    optionOne,
    optionTwo,
    optionThree,
    optionFour,
    sub_question_id
  ) => {
    try {
      const response = await axios.post(
        ApiConstants.revieweraddSubQuestion,
        {
          question_id: id,
          question: question?.trim(),
          solution: solution?.trim(),
          correctOption: correctOption,
          optionOne: optionOne?.trim(),
          optionTwo: optionTwo?.trim(),
          optionThree: optionThree?.trim(),
          optionFour: optionFour?.trim(),
          sub_question_id: sub_question_id
        },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  revieweraddQuestion: async (id, question_type, type_of_question, question, solution, correctOption, optionOne, optionTwo, optionThree, optionFour) => {
    try {
      const response = await axios.post(
        ApiConstants.revieweraddQuestion,
        {
          question_id: id,
          type_of_question: type_of_question?.trim(),
          question_type: question_type?.trim(),
          question: question?.trim(),
          solution: solution?.trim(),
          correctOption: correctOption,
          optionOne: optionOne?.trim(),
          optionTwo: optionTwo?.trim(),
          optionThree: optionThree?.trim(),
          optionFour: optionFour?.trim(),
        },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  reviewerdeleteSubQuestion: async (id) => {
    try {
      const response = await axios.post(
        ApiConstants.reviewerdeleteSubQuestion,
        {
          ids: [id],
        },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  reviewerupdateStatus: async (id, status) => {
    try {
      const response = await axios.put(
        ApiConstants.reviewerupdateStatus,
        {
          question_id: id,
          status:status,
        },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );

      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  getreviewerhistorylist: async (limit,offset, searchQuery,class_id,medium,subject_id,status,startDate,endDate) => {
    try {
      const queryParams = new URLSearchParams({
        limit: limit,
        offset: offset,
        searchQuery: searchQuery,
        class_id:class_id,
        medium: medium,
        subject_id:subject_id,
        status:status,
      });

      if (startDate) {
        queryParams.append('startDate', dayjs(startDate).format('YYYY-MM-DD'));
      } else {
        queryParams.append('startDate', "");
      }
      if (endDate) {
        queryParams.append('endDate', dayjs(endDate).format('YYYY-MM-DD'));
      } else if (startDate && !endDate) {
        queryParams.append('endDate', dayjs(new Date()).format('YYYY-MM-DD'));
      } else {
        queryParams.append('endDate', "");
      }
      const url = `${ApiConstants.getreviewerhistorylist}?${queryParams.toString()}`;
      const response = await axios.get(url,
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  deleteReviewerQuestionList: async (id) => {
    try {
      const response = await axios.post(
        ApiConstants.deleteReviewerQuestionList,
        {
          ids: id,
        },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

};

export default ReviewerService;
